import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAnimalWeightHistoryContext from "../../hooks/useAnimalWeightHistoryContext";
import { AnimalWeightHistoryContextProvider } from "../../contexts/animalWeightHistoryContext";
import { Creators as ReportActions } from "../../store/ducks/report";

import { CardCustom, Title } from "./styles";
import { Col, Icon, Row, Switch, Tabs } from "antd";
import ButtonStandard from "../../components/utils/button";

import DrawerNewAnimalWeightHistory from "../../components/drawers/animalWeightHistory";
import TableAnimalWeightHistory from "./table";
import ReportAnimalWeightHistoryModal from "../../components/modals/reportAnimalWeightHistory";

import { AnimalMeasurementContextProvider } from "../../contexts/animalMeasurementContext";
import AnimalMeasurementLayout from "../animalMeasurement";
import DrawerNewAnimalMeasurement from "../../components/drawers/animalMeasurement";

const { TabPane } = Tabs;

const AnimalWeightHistoryLayout = () => {
  const { translation } = useSelector((state) => state.app);

  const dispatch = useDispatch();

  const {
    tableProperties: { size, page, search },
    initializeData,
    fetchData,
    openOrCloseForm,
    shouldShowWeightsOnlyForActiveAnimals,
    setShouldShowWeightsOnlyForActiveAnimals,
  } = useAnimalWeightHistoryContext();

  const handleCreateNewRecord = () => {
    initializeData(null);
    openOrCloseForm();
  };
  const handleExport = () => {
    dispatch(ReportActions.showModal("ReportAnimalWeightHistory"));
  };

  const handleRefresh = () => {
    fetchData(page, size, {}, search);
  };

  return (
    <CardCustom>
      <Row className="rowHeader" justify="space-between">
        <Col span={8}>
          <Title>{translation.animalWeightHistory.title}</Title>
        </Col>
        <Col span={8}>
          <strong>Buscar pesagens somente de animais Ativos </strong>
          <Switch
            checked={shouldShowWeightsOnlyForActiveAnimals}
            onChange={(checked) =>
              setShouldShowWeightsOnlyForActiveAnimals(checked)
            }
          ></Switch>
        </Col>
        <Col span={8}>
          <Row type="flex" justify="end" gutter={8}>
            <Col>
              <ButtonStandard
                buttonType="typeWithoutBackground"
                onClick={handleRefresh}
              >
                <Icon type="reload" />
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard
                name="buttonCreateBudget"
                buttonType="alternative"
                onClick={handleExport}
              >
                {translation.animalWeightHistory.buttonExport}
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard
                name="buttonCreateBudget"
                buttonType="addNew"
                onClick={handleCreateNewRecord}
              >
                {translation.animalWeightHistory.buttonNew}
              </ButtonStandard>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <TableAnimalWeightHistory />
        </Col>
      </Row>
    </CardCustom>
  );
};

const AnimalWeightHistory = () => {
  const { translation } = useSelector((state) => state.app);

  const [tabSelected, setTabSelected] = useState("weights");

  return (
    <Tabs type="card" activeKey={tabSelected} onTabClick={setTabSelected}>
      <TabPane tab={translation.animalMeasurement.tabs.weights} key="weights">
        <AnimalWeightHistoryContextProvider>
          <AnimalWeightHistoryLayout />
          <DrawerNewAnimalWeightHistory />
          <ReportAnimalWeightHistoryModal />
        </AnimalWeightHistoryContextProvider>
      </TabPane>
      <TabPane
        tab={translation.animalMeasurement.tabs.measurements}
        key="measurements"
      >
        <AnimalMeasurementContextProvider>
          <AnimalMeasurementLayout />
          <DrawerNewAnimalMeasurement />
        </AnimalMeasurementContextProvider>
      </TabPane>
    </Tabs>
  );
};

export default AnimalWeightHistory;
